import React, { useEffect, useState } from 'react';
import axios from 'axios';
import URL from '../constants/ServerUrl';
import { useNavigate } from 'react-router-dom';

const CollectionCenter = () => {
  const [users, setUsers] = useState([]);
  const [farmersCount, setFarmersCount] = useState({});

  const navigate=useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${URL}user`);
        setUsers(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchUsers();
  }, []);


  const handleUserClick = (username) => {
    navigate(`Features?username=${username}`);
  };

  const renderUserItem = ({ item }) => (
    <div
      className="flex flex-col items-center bg-green-300 hover:bg-green-400 text-black p-4 mb-4 rounded-lg cursor-pointer transition duration-300 ease-in-out"
      onClick={() => handleUserClick(item.username)}
    >
      <div className="mb-4">
        <div className="text-lg">{item.contactPerson}</div>
      </div>
      <div className="flex flex-col">
        <div className="mb-2">- UserId: {item.userId}</div>
        <div className="mb-2">- Farmers: {item.farmersCount}</div>
        <div className="mb-2">- Username: {item.username}</div>
        <div className="mb-2">- Address: {item.address}</div>
      </div>
    </div>
  );
  

  return (
    <div className="min-h-screen bg-white text-black">
    <div className="text-3xl font-bold text-center pt-8 mb-6">Choose Collection Center</div>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 p-4 max-w-5xl mx-auto">
      {users.map((item) => (
        <div key={item._id} className="bg-gray-100 rounded-lg p-4">
          {renderUserItem({ item })}
        </div>
      ))}
    </div>
  </div>
  
  );
};

export default CollectionCenter;
